import Route from '@ember/routing/route';

export default class JoinRequestRoute extends Route {}
